import {
  CustomerListSuccess,
  CustomerDetailsSuccess,
  CustomerUnitDetailsSuccess,
  CustomerGetFilterSuccess,
} from '../../actionTypes/customerManagementAction';

const inititalState = {
  customerManagementList: [],
  customerDetails: {},
  customerUnitDetails: {},
  customerFilter: {},
};

export const customerManagementReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CustomerListSuccess:
      return {
        ...state,
        customerManagementList: payload,
      };

    case CustomerDetailsSuccess:
      return {
        ...state,
        customerDetails: payload,
      };

    case CustomerUnitDetailsSuccess:
      return {
        ...state,
        customerUnitDetails: payload,
      };
    case CustomerGetFilterSuccess:
      return {
        ...state,
        customerFilter: payload,
      };
    default:
      return state;
  }
};
